/** @format */

import React, { PureComponent } from 'react';
import GridContainer from '../../components/Grid/GridContainer';
import GridItem from '../../components/Grid/GridItem';
import I18n from '../../components/Translate/I18n';
import { Typography } from '@material-ui/core';
import adescomStyle from '../../assets/jss/adescom/adescomStyle';
import withStyles from '@material-ui/core/styles/withStyles';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import ApiCollectionResponseInterface from '../../interfaces/api/ApiCollectionResponseInterface';
import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import Filter from '../../interfaces/forms/Filter';
import Order from '../../interfaces/forms/Order';
import MvnoBlockContain from '../../interfaces/platform/MvnoBlockContain';
import GetStatusView from './Function/GetStatusView';
import { MvnoBlockFunctionsCollection } from '../../modules/block/BlockContainHelper';
import DefaultView from './Function/DefaultView';
import Card from '@material-ui/core/Card';
import CardBody from '../../components/Card/CardBody';
import Error from './Function/Error';
import Finish from './Function/Finish';

interface MvnoBlockContainsCollection extends ApiCollectionResponseInterface {
    readonly 'hydra:member': Array<MvnoBlockContain> | null;
}

interface MvnoBlockContainsViewProps {
    dispatch: any;
    classes: any;
    mvnoBlockListId: number;
    blockFunctionList: MvnoBlockFunctionsCollection | null;

    setContainFunction(containFunctions: Array<MvnoBlockContain>): void;

    hideView: boolean;
}

interface MvnoBlockContainsViewState {
    blockContainsElements: MvnoBlockContainsCollection | null;
    filters: Array<Filter>;
    orders: Array<Order>;
}

const css = {
    marginTop: '20px',
};

class MvnoBlockContainsView extends PureComponent<MvnoBlockContainsViewProps, MvnoBlockContainsViewState> {
    private itemLoader: ItemLoaders;

    constructor(props: MvnoBlockContainsViewProps, context: MvnoBlockContainsViewState) {
        super(props, context);

        this.state = {
            blockContainsElements: null,
            filters: [
                { name: 'mvnoBlockListId', value: this.props.mvnoBlockListId },
                { name: 'itemsPerPage', value: 9999 },
            ],
            orders: [{ name: 'positionId', value: 'asc' }],
        };

        this.itemLoader = new ItemLoaders(this.props.dispatch);
    }

    componentDidMount(): void {
        this.setState({ blockContainsElements: null }, this.getElements);
    }

    getFunctionBlock = (containFunction: MvnoBlockContain): object | null => {
        const { blockFunctionList } = this.props;
        switch (containFunction.mvnoBlockFunction.functionName) {
            case 'Adescom\\Block\\Operations\\GetStatus':
                return <GetStatusView element={containFunction} functions={blockFunctionList} />;
            case 'Adescom\\Block\\Finish':
                return <Finish element={containFunction} functions={blockFunctionList} />;
            case 'Adescom\\Block\\Error':
                return <Error element={containFunction} functions={blockFunctionList} />;
            default:
                return <DefaultView element={containFunction} functions={blockFunctionList} />;
        }
    };

    getElements = (): void => {
        const { setContainFunction } = this.props;
        const { filters, orders } = this.state;
        this.itemLoader.getListWithCallback(
            FormGeneralHelper.getUrl('/mvno_block_contains'),
            'mvno_block_contains_collection_callback',
            filters,
            orders,
            (data: MvnoBlockContainsCollection) => {
                this.setState({ blockContainsElements: data });
                if (data['hydra:member']) {
                    setContainFunction(data['hydra:member']);
                }
            },
            { dispatchAfterCallback: false, propagateDataToCallback: true, dispatchErrorAfterCallback: true }
        );
    };

    render(): React.ReactNode {
        const { blockContainsElements } = this.state;
        const { blockFunctionList, hideView } = this.props;
        if (hideView && blockContainsElements && blockFunctionList) {
            return (
                <Card>
                    <CardBody>
                        <GridContainer style={css}>
                            <GridItem xs={12}>
                                <Typography variant="subtitle2">
                                    <I18n trans="prov:view.blok_definition" />
                                </Typography>
                            </GridItem>
                            {blockContainsElements['hydra:member'] &&
                                blockContainsElements['hydra:member']?.map((containFunction: MvnoBlockContain) => {
                                    let block = this.getFunctionBlock(containFunction);
                                    if (block) {
                                        return (
                                            <GridItem xs={3} key={'contain_element_' + containFunction.id}>
                                                {block}
                                            </GridItem>
                                        );
                                    }
                                })}
                        </GridContainer>
                    </CardBody>
                </Card>
            );
        }
        return null;
    }
}

export default compose<any, any>(
    connect((): object => {
        return {};
    }),
    withStyles(adescomStyle)
)(MvnoBlockContainsView);
